import { ApiClient } from "../ApiClient";
import config from "../utils/config";
class InvoicesApiClient {
    constructor() {
        this.apiClient = new ApiClient(`${config.gatewayApiUrl}/v2/invoices`);
    }
    getInvoices(type, nextPageHandle) {
        return this.apiClient.get(`/${type}?nextPageHandle=${nextPageHandle}`);
    }
    getInvoice(type, id) {
        return this.apiClient.get(`/${type}/${id}`);
    }
}
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["PendingPayment"] = "4";
    InvoiceStatus["PendingPaymentConfirmation"] = "8";
    InvoiceStatus["ConfirmedPaid"] = "9";
})(InvoiceStatus || (InvoiceStatus = {}));
const invoicesApiClient = new InvoicesApiClient();
export default invoicesApiClient;
